import React from 'react';
import ReactSelect from 'react-select';
import PropTypes from 'prop-types';
import MaterialSelect from '@material-ui/core/Select';
import withStyles from "@material-ui/core/styles/withStyles";
import InputBase from "@material-ui/core/InputBase";
import InputContainer from "../inputContainer";
import InputErrorMessage from "../inputErrorMessage";
import './index.scss';

const BootstrapInput = withStyles((theme) => ({
	root: {
		'label + &': {
			marginTop: theme.spacing(3),
		},
	},
	input: {
		borderRadius: 4,
		position: 'relative',
		backgroundColor: 'transparent',
		fontSize: 16,
		// height: '25px',
		// padding: '10px 26px 10px 12px',
		transition: theme.transitions.create(['border-color', 'box-shadow']),
		fontFamily: [
			'GilroyRegular',
			'BlinkMacSystemFont',
			'"Segoe UI"',
			'Roboto',
			'"Helvetica Neue"',
			'Arial',
			'sans-serif',
			'"Apple Color Emoji"',
			'"Segoe UI Emoji"',
			'"Segoe UI Symbol"',
		].join(','),
		'&:focus': {},
	},
}))(InputBase);

function Select({error, errorMessage, ...props}) {
	return (
		<InputContainer>
			<div className="app-select-container ">
				<MaterialSelect input={<BootstrapInput />} {...props}/>
			</div>
			{error && errorMessage && <InputErrorMessage errorMessage={errorMessage}/>}
		</InputContainer>
	);
}

Select.propTypes = {
	...ReactSelect.propTypes,
	isDisabled: PropTypes.any,
	error: PropTypes.bool,
	errorMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};
export default Select;
